import { isMediaUrl } from '../services/mediaUrl';

/**
 * @param url - Application media URL, e.g. '/.netlify/functions/media/42'.
 * @throws Error if the URL format is invalid.
 */
export const validateMediaImageUrl = (url: string): string => {
    if (!isMediaUrl(url)) {
        throw new Error(`Invalid media URL: ${url}`);
    }

    return url;
};
